import { createConsentManager } from '@iq/consent';

export const consentManager = createConsentManager({
  googleAnalyticsId: 'G-E4W6ZNC5DK',
});